import CustomModal from "../../../common/components/modal/CustomDetailModal";
import { Divider, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import { TitleAndInput } from "../../../common/components/input/TitleAndInput";
import React, { useState } from "react";
import { C3Text } from "../../../common/components/text/CustomText";
import SecondaryButton from "../../../common/components/button/SecondaryButton";
import Translate from "../../../common/translate/Translate";
import PrimaryButton from "../../../common/components/button/PrimaryButton";
import CustomPopup from "../../../common/components/popup/CustomPopup";
import { Theme } from "../../../common/Theme";
import StoreLocationModal from "./StoreLocationModal";
import StoreService from "../../../service/StoreService";

const currencyValues = [
    { label: "Baht(฿)", value: "baht" },
    { label: "Won(₩)", value: "won" },
];

export function StoreSaveModal({ isOpen, onClose, onSave }) {
    const service = new StoreService();
    const [name, setName] = useState("");
    const [selectedCurrency, setSelectedCurrency] = useState("baht");
    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");
    const [city, setCity] = useState("");
    const [selectedStates, setSelectedStates] = useState("");
    const [statesValues, setStatesValues] = useState([
        { label: "Chomburi", value: "Chomburi" },
        { label: "Bangkok", value: "Bangkok" },
        { label: "Pathum Thani", value: "Pathum Thani" },
        { label: "Chiang Mai", value: "Chiang Mai" },
    ]);
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [zip, setZip] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [introduction, setIntroduction] = useState("");
    const [image, setImage] = useState();

    // Cancel Modal
    const [isCancelPopupOpen, setIsCancelPopupOpen] = useState(false);

    const handleCancelClose = () => {
        setIsCancelPopupOpen(false);
    };

    const handleCancelOk = () => {
        setIsCancelPopupOpen(false);
        onClose();
    };

    // location modal
    const [openLocationModal, setOpenLocationModal] = useState(false);

    const handleLocationConfirm = ({ latitude, longitude, zipCode }) => {
        setLatitude(latitude);
        setLongitude(longitude);
        setZip(zipCode);
    };

    // popup
    const [isErrorPopup, setIsErrorPopup] = useState(false);
    const [errorContent, setErrorContent] = useState("프랜차이즈 코드는 영문 대문자 두자리만 허용합니다.");

    const handleSave = () => {
        const reqDto = {
            request: {
                storeName: name,
                storeType: 0,
                currency: selectedCurrency,
                address1: address1,
                address2: address2 || undefined,
                city: city,
                states: selectedStates,
                zipcode: zip || undefined,
                phone: phone,
                lTime: Intl.DateTimeFormat().resolvedOptions().timeZone,
                longitude: latitude && longitude ? [latitude, longitude] : undefined,
                openLocation: true,
                information: introduction || undefined,
                isReservationEnable: true,
            },
        };

        console.log("image: ", image);
        service
            .saveStore(reqDto, image)
            .then(() => {
                onClose();
                if (onSave) onSave();
            })
            .catch((error) => {
                setErrorContent(error.result);
                setIsErrorPopup(true);
            });
    };

    return (
        <CustomModal
            title={"Add Store"}
            isOpen={isOpen}
            onClose={() => setIsCancelPopupOpen(true)}
            width={"552px"}
            side={"right"}
        >
            <SizedBox
                width={"100%"}
                height={"100%"}
                border={"solid 1px #E6E6E9"}
                borderRadius={"16px"}
                alignItem={"flex-start"}
                justifyContent={"flex-start"}
                padding={"20px 20px"}
            >
                <TitleAndInput
                    title={"Name"}
                    type={"normal"}
                    placeholder={"Store Name"}
                    inputValue={name}
                    setInputValue={setName}
                    isRequired
                />
                <Divider marginTop={"11px"} thickness={"0px"} />
                <TitleAndInput
                    title={"Currency"}
                    type={"select"}
                    inputValue={selectedCurrency}
                    setInputValue={setSelectedCurrency}
                    dropdownValues={currencyValues}
                />
                <Divider marginTop={"11px"} marginBottom={"11px"} />
                <TitleAndInput
                    title={"Address"}
                    type={"inputs"}
                    gap={"11px"}
                    inputs={[
                        { type: "normal", placeholder: "Address 1", inputValue: address1, setInputValue: setAddress1 },
                        {
                            type: "normal",
                            placeholder: "Address 2 (Optional)",
                            inputValue: address2,
                            setInputValue: setAddress2,
                        },
                        { type: "normal", placeholder: "City", inputValue: city, setInputValue: setCity },
                        {
                            type: "select",
                            placeholder: "States",
                            inputValue: selectedStates,
                            setInputValue: setSelectedStates,
                            dropdownValues: statesValues,
                        },
                    ]}
                    isRequired
                />
                <Divider marginTop={"11px"} thickness={"0px"} />
                <TitleAndInput
                    title={"Zip"}
                    type={"normal"}
                    placeholder={"Zip Code"}
                    inputValue={zip}
                    setInputValue={setZip}
                    tooltip={
                        <C3Text fontColor={Theme.color.gray500}>
                            Map You can add the exact store location on the map at the push of a button.
                        </C3Text>
                    }
                    gap={"11px"}
                    tooltipTop={"-500%"}
                    buttonIcon={"location_mark_black"}
                    buttonOnClick={() => setOpenLocationModal(true)}
                />
                <Divider marginTop={"11px"} marginBottom={"11px"} />
                <TitleAndInput
                    title={"Phone"}
                    type={"normal"}
                    placeholder={"000-0000-0000"}
                    inputValue={phone}
                    setInputValue={setPhone}
                />
                <Divider marginTop={"11px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                <TitleAndInput
                    title={"Email"}
                    type={"email"}
                    placeholder={"example@domain.com"}
                    inputValue={email}
                    setInputValue={setEmail}
                    isValid={true}
                    isRequired
                />
                <Divider marginTop={"11px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                <TitleAndInput
                    title={"Store Introduction"}
                    type={"textAria"}
                    placeholder={"Store Introduction"}
                    inputValue={introduction}
                    setInputValue={setIntroduction}
                    isValid={true}
                    isRequired
                />
                <Divider marginTop={"11px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                <TitleAndInput
                    title={"Image"}
                    type={"image"}
                    placeholder={"Store Introduction"}
                    inputValue={image}
                    setInputValue={setImage}
                />
            </SizedBox>
            <SizedBox height={"36px"} />
            <Row justifyContent={"flex-end"} width={"100%"}>
                <SecondaryButton
                    onClick={() => setIsCancelPopupOpen(true)}
                    width={"60px"}
                    text={Translate("common.cancel")}
                />
                <SizedBox width={"10px"} />
                <PrimaryButton onClick={handleSave} width={"60px"} text={Translate("common.save")} />
            </Row>
            <CustomPopup
                isOpen={isCancelPopupOpen}
                onClose={handleCancelClose}
                onConfirm={handleCancelOk}
                message={Translate("popup.cancel")}
            />
            {openLocationModal && (
                <StoreLocationModal
                    isOpen={openLocationModal}
                    onClose={() => setOpenLocationModal(false)}
                    onConfirm={handleLocationConfirm}
                />
            )}
            {/* TODO: 번역 확인 필요 */}
            <CustomPopup isOpen={isErrorPopup} onConfirm={() => setIsErrorPopup(false)} message={errorContent} />
        </CustomModal>
    );
}

export default StoreSaveModal;
